/**
 * Registry of every comparison page. The keys here are the URL slugs the
 * router resolves against (`/compare/:slug`). PUBLIC_ROUTES references the
 * same slugs so the prerenderer snapshots each comparison as static HTML.
 *
 * Add a new comparison: drop a `<slug>.ts` file in this folder, import it
 * here, and add the matching entry to `PUBLIC_ROUTES` + the `seo.compareX`
 * translations. That's the full two-line surface.
 */

import type { ComparisonData } from "../types";
import { midjourneyComparison } from "./midjourney";
import { heygenComparison } from "./heygen";
import { klingComparison } from "./kling";

export const COMPARISONS: Readonly<Record<string, ComparisonData>> = {
  [midjourneyComparison.slug]: midjourneyComparison,
  [heygenComparison.slug]: heygenComparison,
  [klingComparison.slug]: klingComparison,
};

export const COMPARISON_SLUGS = Object.keys(COMPARISONS);
